import Link from "next/link";
import { returnUrlTypeCategory } from "~/utils/utils";

const PostCategories = ({ categories, typeCategories }) => {
  return (
    <div className="mt-4 text-sm md:mt-2 lg:mt-0 lg:text-base ">
      {categories.map((category, index) => (
        <Link
          key={category.slug}
          href={
            category.slug != "speciali"
              ? returnUrlTypeCategory(category.slug, typeCategories)
              : "/speciali"
          }
          className="mr-1 py-1 font-bold text-orange hover:underline"
        >
          {category.name.replace("&amp;", " & ")}
          {index < categories.length - 1 ? "," : ""}
        </Link>
      ))}
    </div>
  );
};
export default PostCategories;
